<template>
  <a-layout style="min-height: 100%">
    <a-layout-sider :collapsible="true" :trigger="null" :collapsed="collapsed">
      <div class="web-title">
        <!-- <img src="" alt="" />
        <a-icon :type="user" /> -->
        <div v-show="!collapsed" class="text">铸学教育后台管理</div>
      </div>

      <a-menu mode="inline" theme="dark" :default-selected-keys="[this.$route.path]" :inline-collapsed="collapsed" @select="goto">
        <a-menu-item v-for="menu in menus" :key="menu.path">
          <a-icon :type="menu.icon" />
          <span>{{ menu.text }}</span>
        </a-menu-item>
      </a-menu>
    </a-layout-sider>

    <a-layout>
      <a-layout-header style="background: #fff">
        <a-row type="flex" justify="space-between">
          <a-col>
            <a-space size="large">
              <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" :style="{ fontSize: '20px' }" @click="toggleCollapsed" />
              <a-icon type="reload" :style="{ fontSize: '20px' }" @click="reload" />
            </a-space>
          </a-col>

          <a-col v-if="userInfo">
            <a-dropdown placement="bottomCenter">
              <a-avatar :src="require('../assets/avatar.png')" :size="40" @click="(e) => e.preventDefault()" />
              <a-menu slot="overlay">
                <a-menu-item>
                  <a>你好, {{ userInfo.name }}</a>
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item>
                  <a @click="updatePassword">修改密码</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="logout">退出登录</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </a-col>
        </a-row>
      </a-layout-header>

      <!-- 主要内容 -->
      <a-layout-content style="
          margin: 15px 12px;
          padding: 15px 12px;
          background: #fff;
          min-width: 900px;
        ">
        <router-view v-if="isRouterAlive" />
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { LOGOUT } from '../store/mutation-types';
import config from '../../package.json';

const menus = [
  {
    text: '员工管理',
    icon: 'idcard',
    path: '/staff',
    levels: [0, 1],
  },
  {
    text: '会员管理',
    icon: 'user',
    path: '/user',
    levels: [0, 1, 2],
  },
  {
    text: '科目管理',
    icon: 'profile',
    path: '/subject',
    levels: [0, 1, 2],
  },
  {
    text: '咨询管理',
    icon: 'file-text',
    path: '/consult',
    levels: [0, 1, 2],
  },
];
export default {
  name: 'App',
  components: {},
  data() {
    return {
      menus: [],
      defaultSelectedKeys: [menus[1].path],
      collapsed: false,
      isRouterAlive: true,
    };
  },
  created() {
    this.config = config;
    if (this.userInfo) {
        if (this.userInfo.isNeedUpdatePassword) {
          this.$message.info('修改密码后,才能进入系统');
          this.$router.replace('/login?isNeedUpdatePassword=true');
        }
        const level = this.userInfo.staffLevel;
        this.menus = menus.filter((m) => m.levels.includes(level));
      } else {
        // this.$message.info('请先登录系统')
        this.$router.replace('/login');
      }
  },
  methods: {
    ...mapMutations({
      clearLoginState: LOGOUT,
    }),
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    goto({ key }) {
      this.$router.replace(key);
    },
    logout() {
      this.clearLoginState();
      this.$router.replace('/login');
    },
    updatePassword() {
      this.$router.replace('/login?isNeedUpdatePassword=true');
    },
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true; //再打开
      });
    },
  },
  computed: {
    ...mapState(['userInfo']),
  },
};
</script>

<style lang="stylus" scoped>
.web-title {
  width: 100%;
  height: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .text {
    color: #fff;
    white-space: nowrap;
  }
}

.logo {
  width: 200px;
  background: rgba(255, 255, 255, 1);
  position: absolute;
  bottom: 0;
}
</style>
